<template>
    <div class="main">
        <el-dialog title="修改生产信息" :visible.sync="outerVisible">
          <el-row :gutter="0">
              <el-form
                ref="editUser"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
              >
                <el-col :span="24">
                  <el-form-item label="制令单号" prop="numbers">
                    <el-input
                      v-model="formData.numbers"
                      placeholder="请输入制令单号(不能为空）"
                      clearable
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="零件型号" prop="model">
                    <el-select
                      v-model="formData.model"
                      placeholder="请选择下拉选择零件型号"
                      clearable
                      :style="{ width: '100%' }"
                    >
                      <el-option
                        v-for="val in modelOptions"
                        :key="val"
                        :label="val"
                        :value="val"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="计划数量" prop="output">
                    <el-input-number
                      v-model="formData.output"
                      placeholder="计划数量"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="生产线" prop="line">
                    <el-checkbox-group v-model="formData.line" size="medium">
                      <el-checkbox
                        v-for="val in lineOptions"
                        :key="val"
                        :label="val"
                        >{{ val }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="计划时间" prop="plannedTime ">
                    <el-date-picker
                      type="daterange"
                      v-model="formData.plannedTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :style="{ width: '100%' }"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      range-separator="至"
                      clearable
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="下拉选择" prop="status">
                    <el-select
                      v-model="formData.status"
                      placeholder="请选择下拉选择"
                      clearable
                      :style="{ width: '100%' }"
                    >
                      <el-option
                        v-for="val in statusOptions"
                        :key="val"
                        :label="val"
                        :value="val"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          <div slot="footer" class="dialog-footer">
            <el-button @click="outerVisible = false">取 消</el-button>
            <el-button type="primary" @click="editConfig('editUser')">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="生产计划详情"
          :visible.sync="dialogVisible"
          width="60%"
          :before-close="handleClose">
          <div style="font-size: 0.2rem;">
              <el-row>
                  <el-col :span="6" align="right">开始日期：</el-col>
                  <el-col :span="18" class="infoVal">{{formDa.start}}</el-col>
              </el-row>
              <el-row>
                  <el-col :span="6" align="right">结束日期：</el-col>
                  <el-col :span="18" class="infoVal">{{formDa.end}}</el-col>
              </el-row>
              <el-row>
                  <el-col :span="6" align="right">计划产线：</el-col>
                  <el-col :span="18" class="infoVal">{{formDa.line}}</el-col>
              </el-row>
              <el-row>
                  <el-col :span="6" align="right">制令单号：</el-col>
                  <el-col :span="18" class="infoVal">{{formDa.numbers}}</el-col>
              </el-row>
              <el-row>
                  <el-col :span="6" align="right">零件名称：</el-col>
                  <el-col :span="18" class="infoVal">{{formDa.model}}</el-col>
              </el-row>
              <el-row>
                  <el-col :span="6" align="right">计划产量：</el-col>
                  <el-col :span="18" class="infoVal">{{formDa.output}}</el-col>
              </el-row>
              <el-row>
                  <el-col :span="6" align="right">生产状态：</el-col>
                  <el-col :span="18" class="infoVal">{{formDa.status}}</el-col>
              </el-row>
<!--              <el-row>-->
<!--                  <el-col :span="6" align="right">添加时间：</el-col>-->
<!--                  <el-col :span="18" class="infoVal">{{formDa.created_at}}</el-col>-->
<!--              </el-row>-->
<!--              <el-row>-->
<!--                  <el-col :span="6" align="right">更新时间：</el-col>-->
<!--                  <el-col :span="18" class="infoVal">{{formDa.updated_at}}</el-col>-->
<!--              </el-row>-->
          </div>
<!--          <span slot="footer" class="dialog-footer">-->
<!--            <el-button type="primary" @click="dialogVisible = false">关闭</el-button>-->
<!--          </span>-->
        </el-dialog>
        <div class="manage">
            <el-row>
                <el-col :span="10"><h4>排产管理</h4></el-col>
            </el-row>
            <div class="content">
                <el-table
                    :data="tableData"
                    border
                    max-height="400"
                    style="width: 100%">
                    <el-table-column
                      fixed
                      prop="start"
                      label="日期">
                    </el-table-column>
                    <el-table-column
                      prop="numbers"
                      label="制令单号">
                    </el-table-column>
                    <el-table-column
                      prop="model"
                      label="零件名称">
                    </el-table-column>
                    <el-table-column
                      prop="output"
                      label="产量">
                    </el-table-column>
                    <el-table-column
                      prop="status"
                      label="状态">
                    </el-table-column>
                    <el-table-column
                      fixed="right"
                      label="操作"
                      width="100">
                      <template slot-scope="scope">
                        <el-button @click="checkClick(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
            </div>
        </div>
        <div>
            <el-divider content-position="left"><em>已删除的计划排产</em></el-divider>
            <div class="content">
                <el-table
                  :data="deltableData"
                  style="width: 100%;"
                  max-height="400">
                  <el-table-column
                    prop="start"
                    label="开始日期">
                  </el-table-column>
                  <el-table-column
                    prop="end"
                    label="结束日期">
                  </el-table-column>
                  <el-table-column
                    prop="line"
                    label="生产线">
                  </el-table-column>
                  <el-table-column
                    prop="numbers"
                    label="制令单号">
                  </el-table-column>
                  <el-table-column
                    prop="model"
                    label="零件名称">
                  </el-table-column>
                  <el-table-column
                    prop="output"
                    label="计划产量">
                  </el-table-column>
                  <el-table-column
                    prop="status"
                    label="状态">
                  </el-table-column>
                  <el-table-column
                     fixed="right"
                     label="操作"
                     width="100">
                    <template slot-scope="scope">
                      <el-button @click="putRecover(scope.row)" type="success" size="mini">恢复</el-button>
                    </template>
                  </el-table-column>
                </el-table>
            </div>
        </div>
    </div>

</template>
<style>
.infoVal{
    border-bottom: 1px solid #dddddd;
}
</style>
<script>
    export default {
        name: "adminplan",
        data() {
          return {
              ID: 0,
              formDa: {},
              formData: {
                numbers: undefined,
                model: undefined,
                output: undefined,
                line: [],
                plannedTime: [],
                status: undefined,
              },
              rules: {
                numbers: [
                  {
                    required: true,
                    message: "请输入制令单号(不能为空）",
                    trigger: "blur",
                  },
                ],
                model: [
                  {
                    required: true,
                    message: "请选择下拉选择零件型号",
                    trigger: "change",
                  },
                ],
                output: [
                  {
                    required: true,
                    message: "计划数量",
                    trigger: "blur",
                  },
                ],
                line: [
                  {
                    required: true,
                    type: "array",
                    message: "请至少选择一个line",
                    trigger: "change",
                  },
                ],
                plannedTime: [
                  {
                    required: true,
                    type: "array",
                    message: "请至少选择一个plannedTime ",
                    trigger: "change",
                  },
                ],
                status: [
                  {
                    required: true,
                    message: "请选择下拉选择",
                    trigger: "change",
                  },
                ],
              },
              modelOptions: ["F06锅体","F08锅体","D02锅体","D02加高锅体","D04锅体","D03锅体","AFX001锅体"],
              lineOptions: ["A线","B线"],
              statusOptions: ["未完成","计划未实施","计划实施中","已完成"],
              outerVisible: false, // 修改弹窗
              dialogVisible: false, // 查看弹窗
              formLabelWidth: '120px',
              form: {
                  start: '2016-05-02',
                  numbers: '0015A',
                  model: 'D02锅底',
                  output: 10000,
                  status: '计划未实施',
                },
              tableData: [],
              deltableData: [],
          }
        },
        created() {
            this.getCalendar(); // 读取后端数据
            this.getDelPlan(); // 获取已删除的数据
        },
        methods: {
            //------------------request----------start

            // 获取列表数据
            async getDelPlan(){
                await this.axios.get("/delplan").then((res) => {
                    if(res.data.meta.status === 200) return this.deltableData = res.data.data;
                    return this.$message.warning("获取数据异常！！！");
                }).catch((err) => {
                    this.$message.error("请求异常!!!");
                });
            },
            // 修改计划信息
            async putPlan(data){
                await this.axios.put("/plan",data).then((res) => {
                    if (res.data.meta.status === 200) {
                        this.$message.success(res.data.meta.msg);
                        this.outerVisible = false;
                        return this.getCalendar();
                    }
                    return this.$message.warning("修改无效！！！");
                }).catch((err) => {
                    console.log(err)
                    return this.$message.error("请求异常！！！");
                });
            },
            // 读取后端数据
            async getCalendar(){
                await this.axios.get("/planlist").then((res) => {
                  if(res.data.meta.status === 200){
                    this.filtersDate = res.data.data.filtersDate; // 日期
                    this.filtersModel = res.data.data.filtersModel; // 零件名称
                    this.filtersNumber = res.data.data.filtersNumber; // 制令单号
                    this.filtersState = res.data.data.filtersState; // 计划状态
                    this.tableData = res.data.data.tableData; // 数据列表
                    return
                  }
                  return this.$message.warning("获取数据异常！！！");
                }).catch((err) => {
                    return this.$message.error("请求异常！！！");
                });
            },
            // 恢复软删
            async putRecover(row){
              await this.axios.put("/replan",{id: row.id}).then((res) => {
                  if (res.data.meta.status === 200) {
                      this.$message.success("已恢复成功！！！");
                      this.getDelPlan(); // 获取列表数据
                      return
                  }
                  return this.$message.warning("操作无效！！！");
              }).catch((err) => {
                  return this.$message.error("请求异常！！！");
              });
            },

            //------------------request----------end

            // 关闭弹窗
            handleClose() {
                this.dialogVisible = false;
            },
            // 编辑（获取数据）
            editConfig(formName) {
              this.$refs[formName].validate((valid) => {
                let data = {
                      id: this.ID,
                      numbers: this.formData.numbers,
                      model: this.formData.model,
                      output: this.formData.output,
                      line: this.formData.line[0],
                      status:  this.formData.status,
                      start: this.formData.plannedTime[0],
                      end: this.formData.plannedTime[1],
                    };
                if (valid) this.putPlan(data); // 修改计划信息
              });
            },
            // 查看
            checkClick(row) {
                this.formDa = JSON.parse(JSON.stringify(row));
                this.dialogVisible = true;
            },
            // 编辑
            editClick(row) {
                this.ID = row.id;
                this.formData = JSON.parse(JSON.stringify({
                    numbers: row.numbers,
                    model: row.model,
                    output: row.output,
                    line: [row.line],
                    status: row.status,
                    plannedTime: [],
                }));
                this.outerVisible = true;
            },

        },
    }
</script>

<style scoped>

</style>